<template>
	<span>
		<v-container>
			<v-form ref="form" v-model="valid">
				<v-textarea
					hint="Ecrire {link} pour inclure le lien du subbot."
					:rules="messageRules"
					persistent-hint
					label="Message"
					v-model="message"
				></v-textarea>
				{{ getMessageHint(isAsko) }}
				<br />
				Exemple : {if tu}tu peux{else}vous pouvez{endif}
				<br />

				<v-textarea readonly :label="labelMT" v-model="messageMT"></v-textarea>
				<v-textarea readonly :label="labelFV" v-model="messageFV"></v-textarea>
				<v-textarea v-if="isAsko" readonly :label="labelMT2" v-model="messageMT2"></v-textarea>
				<v-textarea v-if="isAsko" readonly :label="labelFV2" v-model="messageFV2"></v-textarea>
			</v-form>
			<v-btn color="primary" @click="save">sauvegarder</v-btn>
		</v-container>
	</span>
</template>
<script>
import { SUCCESS, ERROR, regexpDates, getMessageHint } from '../../variables'
export default {
	props: ['subBotId', 'baseMessage', 'isAsko'],
	data() {
		return {
			valid: false,
			message: null,
			messageRules: [
				(v) => !!v || 'Message requis',
				// (v) => (!!v && v.indexOf('{link}') !== -1) || "{link} n'est pas présent",
			],
		}
	},
	computed: {
		formatedDate() {
			return new Date().toLocaleString('fr').split(/\s|,/)[0]
		},
		labelMT() {
			return `Message tutoiement masculin : ${this.messageMT.length} / 145 ${this.isAsko ? 'chien' : ''} `
		},
		labelFV() {
			return `Message vouvoiement féminin : ${this.messageFV.length} / 145 ${this.isAsko ? 'chienne' : ''}`
		},
		labelMT2() {
			return `Message tutoiement masculin : ${this.messageMT.length} / 145 ${this.isAsko ? 'chat' : ''} `
		},
		labelFV2() {
			return `Message vouvoiement féminin : ${this.messageFV.length} / 145 ${this.isAsko ? 'chatte' : ''}`
		},
		messageMT() {
			if (!this.message) {
				return ''
			}
			let res = this.message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chien')
				.replace(/{prenom}/g, 'Pierre')
				.replace(/{nomAnimal}/g, 'Pixel')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupont')
				.replace(/{mail}/g, 'pierre@gmail.com')
			return this.formatMessage(res, { tu_vous: 'tu', genre: 'M', genreAnimal: 'M', espece: 'chien' })
		},
		messageFV() {
			if (!this.message) {
				return ''
			}

			let res = this.message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chienne')
				.replace(/{prenom}/g, 'Marie-Dominique')
				.replace(/{nomAnimal}/g, 'Checky')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupond')
				.replace(/{mail}/g, 'marie.dominique@gmail.com')
			return this.formatMessage(res, { tu_vous: 'vous', genre: 'F', genreAnimal: 'F', espece: 'chienne' })
		},
		messageMT2() {
			if (!this.message) {
				return ''
			}
			let res = this.message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chat')
				.replace(/{prenom}/g, 'Pierre')
				.replace(/{nomAnimal}/g, 'Pixel')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupont')
				.replace(/{mail}/g, 'pierre@gmail.com')
			return this.formatMessage(res, { tu_vous: 'tu', genre: 'M', genreAnimal: 'M', espece: 'chat' })
		},
		messageFV2() {
			if (!this.message) {
				return ''
			}

			let res = this.message
				.replace(/{link}/g, 'https://exemplexxxx.com')
				.replace(/{espece}/g, 'chatte')
				.replace(/{prenom}/g, 'Marie-Dominique')
				.replace(/{nomAnimal}/g, 'Checky')
				.replace(regexpDates, this.formatedDate)
				.replace(/{nom}/g, 'dupond')
				.replace(/{mail}/g, 'marie.dominique@gmail.com')
			return this.formatMessage(res, { tu_vous: 'vous', genre: 'F', genreAnimal: 'F', espece: 'chatte' })
		},
	},
	methods: {
		getMessageHint,
		formatCondition(conditionString, params) {
			let ifCondition = conditionString.substring(3, conditionString.indexOf('}'))

			ifCondition = ifCondition.replace(/ /g, '')
			const value =
				ifCondition === 'tu' || ifCondition === 'vous'
					? params.tu_vous
					: ifCondition === 'M' || ifCondition === 'F'
					? params.genre
					: ifCondition === 'animalM' || ifCondition === 'animalF'
					? `animal${params.genreAnimal}`
					: ifCondition === 'chien' || ifCondition === 'chienne' || ifCondition === 'chatte' || ifCondition === 'chat'
					? params.espece.toLowerCase()
					: null
			if (ifCondition === value) {
				let elseIndex = conditionString.indexOf('{else}')
				elseIndex = elseIndex === -1 ? conditionString.length : elseIndex
				conditionString = conditionString.substring(conditionString.indexOf('}') + 1, elseIndex)
			} else {
				let elseIndex = conditionString.indexOf('{else}')
				if (elseIndex == -1) {
					conditionString = ''
				} else {
					conditionString = conditionString.substring(elseIndex + 6, conditionString.length)
				}
			}

			return conditionString
		},
		formatMessage(message, params) {
			let nextIf, endIf
			let currentIf = message.indexOf('{if')
			let error = false

			while (currentIf !== -1 && !error) {
				endIf = message.indexOf('{endif}', currentIf + 1)
				if (endIf === -1) {
					error = true
				} else {
					nextIf = message.indexOf('{if', currentIf + 1)
					while (nextIf !== -1 && nextIf < endIf) {
						currentIf = nextIf
						nextIf = message.indexOf('{if', currentIf + 1)
					}

					let conditionString = message.substring(currentIf, endIf)
					message =
						message.substring(0, currentIf) +
						this.formatCondition(conditionString, params) +
						message.substring(endIf + 7, message.length)
				}
				currentIf = message.indexOf('{if')
			}
			return message
		},
		save() {
			this.$refs.form.resetValidation()
			if (this.valid) {
				this.axios
					.put('subBots/' + this.subBotId, {
						message: this.message,
					})
					.then((response) => {
						this.$store.dispatch(SUCCESS, 'Message enregistré')
					})
					.catch((err) => {
						this.$store.dispatch(ERROR, err)
					})
			} else {
				setTimeout(
					function() {
						this.$refs.form.validate()
					}.bind(this),
					200,
				)
			}
		},
	},
	watch: {
		baseMessage() {
			this.message = this.baseMessage
		},
	},
	mounted() {
		this.message = this.baseMessage
	},
}
</script>



// WEBPACK FOOTER //
// src/components/subBots/message.form.vue